// import React, {useState,useEffect} from "react"
// import { useSelector, useDispatch } from "react-redux";
// import '../customerInformation/CustomerInformation.css';
// import Header from "../header/Header";
// import Menu from "../menu/Menu";
// import red_line from '../../img/red_line.png';
// import { MobileMenu } from "../mobileMenu/MobileMenu";
// import CustomerForm from '../../components/customerInformation/customerForm/CustomerForm';
// import { FooterButtons } from "../common/buttons/FooterButtons";
// import '../pageSize/PageSize.css';

// const CustomerInformation = () => {
//     const [isMobile, setIsMobile] = useState(window.matchMedia("(max-width: 600px)").matches);   
//     const [isMenuOpen, setIsMenuOpen] = useState(false);
//     const [currentPage, setCurrentPage] = useState(window.location.pathname);
//     const userData = useSelector(state => state.customer);
//     const complaintType = useSelector((state) => state.complaint.complaintType);

//     useEffect(() => {
//         const handleWindowResize = () => {
//             setIsMobile(window.matchMedia("(max-width: 767px)").matches);
//         };
//         window.addEventListener("resize", handleWindowResize);
//         return () => {
//             window.removeEventListener("resize", handleWindowResize);
//         };
//     }, []);

//     useEffect(() => {
//         function handlePageChange() {
//             setCurrentPage(window.location.pathname);
//         }
//         window.addEventListener("popstate", handlePageChange);
//         return () => {
//             window.removeEventListener("popstate", handlePageChange);
//         };
//     }, [currentPage]);

//     return ( 
//     <div className="page-size">
//         <Header/>
//         {isMobile ? <MobileMenu isOpen={isMenuOpen} onClick={() => setIsMenuOpen(!isMenuOpen)}/> : <Menu isOpen={isMenuOpen} onClick={() => setIsMenuOpen(!isMenuOpen)}/>}
//        <div className="customer-information-container">
//            <div className="customer-information-title">
//                    <img style={{marginLeft: "0px"}} src={red_line} className='red-line'/>
//                    <p className="customer-inf-text">Dane klienta</p>
//            </div>
//             <CustomerForm complaintType={complaintType}/>
//        </div>
//     </div>
//    )
// }

// export default CustomerInformation;


import React, {useState,useEffect} from "react"
import { useSelector, useDispatch } from "react-redux";
import '../customerInformation/CustomerInformation.css';
import Header from "../header/Header";
import Menu from "../menu/Menu";
import red_line from '../../img/red_line.png';
import { MobileMenu } from "../mobileMenu/MobileMenu";
import CustomerForm from '../../components/customerInformation/customerForm/CustomerForm';
import { FooterButtons } from "../common/buttons/FooterButtons";
import '../pageSize/PageSize.css';
import { NextAndBackButtons } from "../common/buttons/nextAndBackButtons/NextAndBackButtons";
import NewMobileMenu from "../common/newMenu/NewMobileMenu";
import NewDesktopMenu from "../common/newMenu/NewDesktopMenu";
import { SectionTitle } from "../common/sectionTitle/SectionTitle";
import { MENU_ITEMS } from "../common/newMenu/menuItems/MenuItems";

const CustomerInformation = () => {
  const [isMobile, setIsMobile] = useState(window.matchMedia("(max-width: 600px)").matches);   
  const complaintType = useSelector((state) => state.complaint.complaintType);

  useEffect(() => {
    const handleWindowResize = () => {
      setIsMobile(window.matchMedia("(max-width: 767px)").matches);
    };
    window.addEventListener("resize", handleWindowResize);
    return () => window.removeEventListener("resize", handleWindowResize);
  }, []);

  return (
    <div className="page-size">
      <Header />
      {isMobile 
        ? <NewMobileMenu items={MENU_ITEMS}/> 
        : <NewDesktopMenu items={MENU_ITEMS}/>}

      <div className="main-content" style={{ marginTop: '200px' }}>
        <SectionTitle text="Dane klienta" />
        <p className="client-type-subtitle">
          Wprowadź dane klienta w formularzu
        </p>
        <CustomerForm complaintType={complaintType} />
      </div>
    </div>
  );
}

export default CustomerInformation;